import { useTranslation } from "react-i18next";import React from 'react';
import { Card, CardContent } from '@/shared/components/ui/card';
import { cn } from '@/shared/utils';

export const CommunicationsStatCard = ({
  title,
  value,
  icon: Icon,
  color = 'violet',
  subtitle,
  trend,
  prefix = '',
  suffix = '',
  className
}) => {const { t } = useTranslation("comms");
  const colorMap = {
    violet: 'bg-violet-500/10 text-violet-600',
    teal: 'bg-teal-500/10 text-teal-600',
    blue: 'bg-blue-500/10 text-blue-600',
    green: 'bg-emerald-500/10 text-emerald-600',
    amber: 'bg-amber-500/10 text-amber-600',
    red: 'bg-red-500/10 text-red-600',
    orange: 'bg-orange-500/10 text-orange-600'
  };

  const borderColorMap = {
    violet: 'border-l-violet-500',
    teal: 'border-l-teal-500',
    blue: 'border-l-blue-500',
    green: 'border-l-emerald-500',
    amber: 'border-l-amber-500',
    red: 'border-l-red-500',
    orange: 'border-l-orange-500'
  };

  return (
    <Card className={cn(
      "card-elevated border-l-4 transition-all duration-200 hover:shadow-lg",
      borderColorMap[color],
      className
    )}>
      <CardContent className="p-5">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
              {title}
            </p>
            <p className="text-2xl font-bold mt-2 text-foreground font-['Space_Grotesk']">
              {prefix}{typeof value === 'number' ? value.toLocaleString() : value}{suffix}
            </p>
            {subtitle &&
            <p className="text-sm text-muted-foreground mt-1">
                {subtitle}
              </p>
            }
            {trend &&
            <p className={cn(
              "text-sm mt-1 font-medium flex items-center gap-1",
              trend.type === 'up' ? 'text-emerald-600' : trend.type === 'down' ? 'text-red-600' : 'text-muted-foreground'
            )}>
                <span>{trend.type === 'up' ? '↑' : trend.type === 'down' ? '↓' : '→'}</span>
                <span>{trend.value}%</span>
              </p>
            }
          </div>
          {Icon &&
          <div className={cn(
            "flex h-12 w-12 items-center justify-center rounded-xl",
            colorMap[color]
          )}>
              <Icon className="h-6 w-6" />
            </div>
          }
        </div>
      </CardContent>
    </Card>);

};